export default "__VITE_ASSET__d0cddd96__"